import React, {useEffect, useState} from 'react';
import { Grid } from '@mui/material';
import MidiOutSelector from "./MidiOutSelector";
import DeviceIdSelector from "./DeviceIdSelector";
import Button from "@mui/material/Button";
import {globalChangeMessage, noiseThresholdAddress, outLevelAddress, reverbLevelAddress} from "./utils";
import VerticalSliderSettingPanel from "./VerticalSliderSettingPanel";

export default function GlobalSoundSetting({ midiOutputs }) {
    const [midiOut, setMidiOut] = useState(null);
    const [midiOut2, setMidiOut2] = useState(null);
    const [midiOutId, setMidiOutId] = useState(() => {
        const savedData = localStorage.getItem('midiOutId');
        return savedData ? JSON.parse(savedData) : null;
    });
    const [midiOutId2, setMidiOutId2] = useState(() => {
        const savedData = localStorage.getItem('midiOutId2');
        return savedData ? JSON.parse(savedData) : null;
    });
    const [deviceId, setDeviceId] = useState(() => {
        const savedData = localStorage.getItem('deviceId');
        const number = parseInt(savedData ? JSON.parse(savedData) : 1);
        return number >= 0 && number < 32 ? number : 0;
    });
    const [deviceId2, setDeviceId2] = useState(() => {
        const savedData = localStorage.getItem('deviceId2');
        const number = parseInt(savedData ? JSON.parse(savedData) : 1);
        return number >= 0 && number < 32 ? number : 1;
    });

    const [outLevel, setOutLevel] = useState(() => {
        const savedOutLevel = localStorage.getItem('outLevel');
        return savedOutLevel ? JSON.parse(savedOutLevel) : 50;
    });
    const [noiseThreshold, setNoiseThreshold] = useState(() => {
        const savedNoiseThreshold = localStorage.getItem('noiseThreshold');
        return savedNoiseThreshold ? JSON.parse(savedNoiseThreshold) : 20;
    });
    const [reverbLevel, setReverbLevel] = useState(() => {
        const savedReverbLevel = localStorage.getItem('reverbLevel');
        return savedReverbLevel ? JSON.parse(savedReverbLevel) : 50;
    });
    const [outLevel2, setOutLevel2] = useState(() => {
        const savedOutLevel2 = localStorage.getItem('outLevel2');
        return savedOutLevel2 ? JSON.parse(savedOutLevel2) : 50;
    });
    const [noiseThreshold2, setNoiseThreshold2] = useState(() => {
        const savedNoiseThreshold2 = localStorage.getItem('noiseThreshold2');
        return savedNoiseThreshold2 ? JSON.parse(savedNoiseThreshold2) : 20;
    });
    const [reverbLevel2, setReverbLevel2] = useState(() => {
        const savedReverbLevel2 = localStorage.getItem('reverbLevel2');
        return savedReverbLevel2 ? JSON.parse(savedReverbLevel2) : 50;
    });

    useEffect(() => {
        localStorage.setItem('outLevel', JSON.stringify(outLevel));
        globalChangeMessage(midiOut, deviceId, outLevel, outLevelAddress);
    }, [deviceId, midiOut, outLevel]);

    useEffect(() => {
        localStorage.setItem('outLevel2', JSON.stringify(outLevel2));
        globalChangeMessage(midiOut2, deviceId2, outLevel2, outLevelAddress);
    }, [deviceId2, midiOut2, outLevel2]);

    useEffect(() => {
        localStorage.setItem('noiseThreshold', JSON.stringify(noiseThreshold));
        globalChangeMessage(midiOut, deviceId, noiseThreshold, noiseThresholdAddress);
    }, [deviceId, midiOut, noiseThreshold]);

    useEffect(() => {
        localStorage.setItem('noiseThreshold2', JSON.stringify(noiseThreshold2));
        globalChangeMessage(midiOut2, deviceId2, noiseThreshold2, noiseThresholdAddress);
    }, [deviceId2, midiOut2, noiseThreshold2]);

    useEffect(() => {
        localStorage.setItem('reverbLevel', JSON.stringify(reverbLevel));
        globalChangeMessage(midiOut, deviceId, reverbLevel, reverbLevelAddress);
    }, [deviceId, midiOut, reverbLevel]);

    useEffect(() => {
        localStorage.setItem('reverbLevel2', JSON.stringify(reverbLevel2));
        globalChangeMessage(midiOut2, deviceId2, reverbLevel2, reverbLevelAddress);
    }, [deviceId2, midiOut2, reverbLevel2]);

    useEffect(() => {
        localStorage.setItem('midiOutId', JSON.stringify(midiOutId));
    }, [midiOutId]);

    useEffect(() => {
        localStorage.setItem('midiOutId2', JSON.stringify(midiOutId2));
    }, [midiOutId2]);

    useEffect(() => {
        localStorage.setItem('deviceId', JSON.stringify(deviceId));
    }, [deviceId]);

    useEffect(() => {
        localStorage.setItem('deviceId2', JSON.stringify(deviceId2));
    }, [deviceId2]);
    const handleReset = () => {
        setOutLevel(50);
        setNoiseThreshold(20);
        setReverbLevel(50);
    }

    const handleReset2 = () => {
        setOutLevel2(50);
        setNoiseThreshold2(20);
        setReverbLevel2(50);
    }

    return (
        <div >
            <Grid container spacing={3} style={{ margin: '10px' }}>
                <Grid item xs={4}>
                    <MidiOutSelector setMidiOut={setMidiOut} initialId={midiOutId} setInitialId={setMidiOutId} midiOutputs={midiOutputs}/>
                </Grid>
                <Grid item xs={2}>
                    <DeviceIdSelector deviceId={deviceId} setCDeviceId={setDeviceId}/>
                </Grid>
                <Grid item xs={1}>
                </Grid>
                <Grid item xs={2} container alignItems="center">
                    <Button variant="contained" color="secondary" onClick={handleReset}>全て規定値にリセット</Button>
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={1}>
                </Grid>
                <Grid item xs={3}>
                    <VerticalSliderSettingPanel
                        label={`Out Level<br/>${outLevel * 2}%`}
                        value={outLevel * 2}
                        onchange={(event, newValue) => setOutLevel(newValue / 2)}
                        min={30}
                        max={200}
                        step={2}
                        marks={[{value: 30, label: '30%' }, { value: 100, label: '100%' }, { value: 200, label: '200%' },]}
                    />
                </Grid>
                <Grid item xs={3}>
                    <VerticalSliderSettingPanel
                        label={`Noise Suppressor threshold<br/>${noiseThreshold > 20 ? '+' : ''}${noiseThreshold - 20}dB`}
                        value={noiseThreshold - 20}
                        onchange={(event, newValue) => setNoiseThreshold(newValue + 20)}
                        min={-20}
                        max={20}
                        step={1}
                        marks={[{value: -20, label: '-20dB' }, { value: 0, label: '0dB' }, { value: 20, label: '+20dB' },]}
                    />
                </Grid>
                <Grid item xs={3}>
                    <VerticalSliderSettingPanel
                        label={`Reverb Level<br/>${reverbLevel * 2}%`}
                        value={reverbLevel * 2}
                        onchange={(event, newValue) => setReverbLevel(newValue / 2)}
                        min={30}
                        max={200}
                        step={2}
                        marks={[{value: 30, label: '30%' }, { value: 100, label: '100%' }, { value: 200, label: '200%' },]}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={3} style={{ margin: '10px' }}>
                <Grid item xs={4}>
                    <MidiOutSelector setMidiOut={setMidiOut2} initialId={midiOutId2} setInitialId={setMidiOutId2} midiOutputs={midiOutputs}/>
                </Grid>
                <Grid item xs={2}>
                    <DeviceIdSelector deviceId={deviceId2} setCDeviceId={setDeviceId2}/>
                </Grid>
                <Grid item xs={1}>
                </Grid>
                <Grid item xs={2} container alignItems="center">
                    <Button variant="contained" color="secondary" onClick={handleReset2}>全て規定値にリセット</Button>
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={1}>
                </Grid>
                <Grid item xs={3}>
                    <VerticalSliderSettingPanel
                        label={`Out Level<br/>${outLevel2 * 2}%`}
                        value={outLevel2 * 2}
                        onchange={(event, newValue) => setOutLevel2(newValue / 2)}
                        min={30}
                        max={200}
                        step={2}
                        marks={[{value: 30, label: '30%' }, { value: 100, label: '100%' }, { value: 200, label: '200%' },]}
                    />
                </Grid>
                <Grid item xs={3}>
                    <VerticalSliderSettingPanel
                        label={`Noise Suppressor threshold<br/>${noiseThreshold2 > 20 ? '+' : ''}${noiseThreshold2 - 20}dB`}
                        value={noiseThreshold2 - 20}
                        onchange={(event, newValue) => setNoiseThreshold2(newValue + 20)}
                        min={-20}
                        max={20}
                        step={1}
                        marks={[{value: -20, label: '-20dB' }, { value: 0, label: '0dB' }, { value: 20, label: '+20dB' },]}
                    />
                </Grid>
                <Grid item xs={3}>
                    <VerticalSliderSettingPanel
                        label={`Reverb Level<br/>${reverbLevel2 * 2}%`}
                        value={reverbLevel2 * 2}
                        onchange={(event, newValue) => setReverbLevel2(newValue / 2)}
                        min={30}
                        max={200}
                        step={2}
                        marks={[{value: 30, label: '30%' }, { value: 100, label: '100%' }, { value: 200, label: '200%' },]}
                    />
                </Grid>
            </Grid>
        </div>
    );
}
